export default [
    {
        key: "elektropanel",
        allArray: "allElektropanelStoyka",
        activeArray: "activeElektropanelStoyka",
        position: "top",
    },
];
